// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DEV-ONLY: shared devtools stack and panel shell */

.devtools-stack {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
}

.devtools-panel-shell {
  flex-shrink: 0;
  background: #2d2a26;
  color: #e0ddd8;
  border-radius: 8px;
  font-size: 11px;
  font-family: system-ui, sans-serif;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  min-width: 200px;
}

.devtools-panel-shell__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  background: #3a3632;
  border-bottom: 1px solid #4a4541;
}

.devtools-panel-shell__actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.devtools-panel-shell__action {
  padding: 4px 8px;
  font-size: 11px;
  cursor: pointer;
  background: transparent;
  color: #e8e6e3;
  border: 1px solid #5a5551;
  border-radius: 6px;
}

.devtools-panel-shell__action:hover {
  background: rgba(255, 255, 255, 0.06);
}

.devtools-panel-shell__action--danger {
  border-color: rgba(223, 119, 95, 0.7);
  color: rgba(223, 119, 95, 1);
}

.devtools-panel-shell__action--danger:hover {
  background: rgba(223, 119, 95, 0.12);
}

.devtools-panel-shell__title {
  font-weight: 700;
  color: #8eb9b2;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.devtools-panel-shell__toggle {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  background: #4a4541;
  color: #e8e6e3;
  border: 1px solid #5a5551;
  border-radius: 4px;
}

.devtools-panel-shell__toggle:hover {
  background: #5a5551;
}

.devtools-panel-shell__body {
  padding: 10px 12px;
  max-height: min(50vh, 420px);
  overflow-y: auto;
  color: #e0ddd8;
}

.devtools-panel-shell__body .design-overlay__unit,
.devtools-panel-shell__body .layout-inspector-panel__label,
.devtools-panel-shell__body .layout-inspector-panel__hint,
.devtools-panel-shell__body .layout-inspector-panel__tune-hint,
.devtools-panel-shell__body .layout-inspector-panel__tune-original,
.devtools-panel-shell__body .layout-inspector-panel__tune-unit {
  color: #c9c5bf;
}
`, "",{"version":3,"sources":["webpack://./src/components/devtools/DevtoolsPanels.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB","sourcesContent":["/* DEV-ONLY: shared devtools stack and panel shell */\n\n.devtools-stack {\n  position: fixed;\n  top: 16px;\n  right: 16px;\n  z-index: 10000;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n}\n\n.devtools-panel-shell {\n  flex-shrink: 0;\n  background: #2d2a26;\n  color: #e0ddd8;\n  border-radius: 8px;\n  font-size: 11px;\n  font-family: system-ui, sans-serif;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n  min-width: 200px;\n}\n\n.devtools-panel-shell__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  background: #3a3632;\n  border-bottom: 1px solid #4a4541;\n}\n\n.devtools-panel-shell__actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.devtools-panel-shell__action {\n  padding: 4px 8px;\n  font-size: 11px;\n  cursor: pointer;\n  background: transparent;\n  color: #e8e6e3;\n  border: 1px solid #5a5551;\n  border-radius: 6px;\n}\n\n.devtools-panel-shell__action:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.devtools-panel-shell__action--danger {\n  border-color: rgba(223, 119, 95, 0.7);\n  color: rgba(223, 119, 95, 1);\n}\n\n.devtools-panel-shell__action--danger:hover {\n  background: rgba(223, 119, 95, 0.12);\n}\n\n.devtools-panel-shell__title {\n  font-weight: 700;\n  color: #8eb9b2;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.devtools-panel-shell__toggle {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  background: #4a4541;\n  color: #e8e6e3;\n  border: 1px solid #5a5551;\n  border-radius: 4px;\n}\n\n.devtools-panel-shell__toggle:hover {\n  background: #5a5551;\n}\n\n.devtools-panel-shell__body {\n  padding: 10px 12px;\n  max-height: min(50vh, 420px);\n  overflow-y: auto;\n  color: #e0ddd8;\n}\n\n.devtools-panel-shell__body .design-overlay__unit,\n.devtools-panel-shell__body .layout-inspector-panel__label,\n.devtools-panel-shell__body .layout-inspector-panel__hint,\n.devtools-panel-shell__body .layout-inspector-panel__tune-hint,\n.devtools-panel-shell__body .layout-inspector-panel__tune-original,\n.devtools-panel-shell__body .layout-inspector-panel__tune-unit {\n  color: #c9c5bf;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
